import { forwardRef } from 'react';

import SideMenu from './SideMenu';

const AppContainerLayout = forwardRef<HTMLDivElement, AppContainerLayoutProps>(
  ({ children }, ref) => {
    return (
      <div className="flex">
        <div className="w-80">
          <SideMenu />
        </div>
        <main className="flex-1 py-8 pl-6 h-screen overflow-auto" ref={ref}>
          {children}
        </main>
      </div>
    );
  },
);
export type AppContainerLayoutProps = {
  children: React.ReactNode;
};

export default AppContainerLayout;
